import React from "react";
import {
  FaPrint,
  FaCamera,
  FaMicrophone,
  FaRing,
  FaUsers,
} from "react-icons/fa";

export default function MitraComp() {
  const services = [
    {
      icon: <FaPrint />,
      title: "Percetakan",
    },
    {
      icon: <FaCamera />,
      title: "Studio Photo",
    },
    {
      icon: <FaCamera />,
      title: "Photographer",
    },
    {
      icon: <FaMicrophone />,
      title: "MC",
    },
    {
      icon: <FaRing />,
      title: "Wedding Planner",
    },
    {
      icon: <FaUsers />,
      title: "Dan Banyak Lagi",
    },
  ];

  return (
    <section
      className="mitra-section"
      style={{
        width: "100%",
        padding: "100px 20px",
        background: "#fff",
        overflow: "hidden",
        position: "relative",
        fontFamily: "sans-serif",
      }}
    >
      {/* DESKTOP BACKGROUND MAP */}
      <div
        className="map-bg"
        style={{
          position: "absolute",
          top: "50%",
          right: "-8%",
          transform: "translateY(-50%)",
          width: "75%",
          height: "100%",
          backgroundImage:
            "url(https://image.invb.my.id/64b9058e88cc900dc65eb486/1779327599780-chatgpt-image-may-21-2026-083815-am-1.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center right",
          backgroundSize: "contain",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      {/* GLOW */}
      <div
        className="map-glow"
        style={{
          position: "absolute",
          width: "700px",
          height: "700px",
          borderRadius: "50%",
          background: "#ff0a8a15",
          filter: "blur(100px)",
          right: "-100px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 0,
        }}
      />

      {/* CONTENT */}
      <div
        className="mitra-wrapper"
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1350px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          alignItems: "center",
          gap: "60px",
        }}
      >
        {/* LEFT CONTENT */}
        <div className="mitra-content" style={{ maxWidth: "430px" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "#ffe4f3",
              color: "#ff0a8a",
              padding: "10px 18px",
              borderRadius: "999px",
              fontWeight: 700,
              marginBottom: "24px",
              fontSize: "14px",
            }}
          >
            Mitra Kami
          </div>

          <h1
            className="mitra-title"
            style={{
              fontSize: "58px",
              lineHeight: "1.1",
              marginBottom: "24px",
              color: "#111",
              fontWeight: 800,
            }}
          >
            Sudah Tersebar
            <br />
            di Seluruh
            <span style={{ color: "#ff0a8a" }}> Indonesia</span>
          </h1>

          <p
            className="mitra-desc"
            style={{
              fontSize: "18px",
              lineHeight: "32px",
              color: "#666",
              marginBottom: "40px",
            }}
          >
            Membantu lebih banyak bisnis berkembang seperti{" "}
            <span style={{ color: "#ff0a8a" }}>
              percetakan, studio photo, photographer,
            </span>{" "}
            MC, wedding planner, dan berbagai usaha kreatif lainnya di seluruh
            Indonesia.
          </p>

          {/* MOBILE MAP IMAGE */}
          <div className="mobile-map-wrapper">
            <img
              src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1779327599780-chatgpt-image-may-21-2026-083815-am-1.png"
              alt="Indonesia Map"
              className="mobile-map"
            />
          </div>

          {/* SERVICES */}
          <div
            className="services-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "16px",
            }}
          >
            {services.map((item, index) => (
              <div
                key={index}
                className="service-card"
                style={{
                  background: "rgba(255,255,255,0.85)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.7)",
                  borderRadius: "22px",
                  padding: "16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                  transition: "0.3s",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "16px",
                    background: "#ff0a8a",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  {item.icon}
                </div>

                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#222",
                  }}
                >
                  {item.title}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* RESPONSIVE */}
      <style>
        {`
          .mobile-map-wrapper {
            display: none;
          }

          @media (max-width: 1100px) {
            .mitra-wrapper {
              grid-template-columns: 1fr !important;
            }

            .mitra-content {
              max-width: 100% !important;
            }

            .map-bg {
              opacity: 0.15;
            }
          }

          @media (max-width: 768px) {
            .mitra-section {
              padding: 70px 20px !important;
            }

            .mitra-title {
              font-size: 42px !important;
              line-height: 1.2 !important;
            }

            .mitra-desc {
              font-size: 16px !important;
              line-height: 28px !important;
            }

            .services-grid {
              grid-template-columns: 1fr !important;
            }

            .service-card {
              padding: 14px !important;
            }

            /* HIDE BACKGROUND MAP */
            .map-bg {
              display: none !important;
            }

            /* SHOW IMAGE MAP */
            .mobile-map-wrapper {
              display: block;
              margin-bottom: 35px;
            }

            .mobile-map {
              width: 100%;
              display: block;
              object-fit: contain;
            }

            .map-glow {
              width: 350px !important;
              height: 350px !important;
              right: -150px !important;
            }
          }

          @media (max-width: 480px) {
            .mitra-title {
              font-size: 34px !important;
            }

            .mitra-desc {
              font-size: 15px !important;
              line-height: 26px !important;
            }
          }
        `}
      </style>
    </section>
  );
}